import React from 'react';
import { Component, FilterCombo, noDataDropDownRender, Position } from "puzzle";
import virtualScroll from "../../../VirtualScroll";
import { PA_CLIENT } from "../../Types";
import { GRID_CONTENT_INFO } from "../../../Drawer/Tabs/Types";
import { omit } from "lodash";
import {
  ComboBoxFilterChangeEvent
} from '@progress/kendo-react-dropdowns';

type PROPS = {
  onChange?: () => void
  pageSize: number
  projectId: number | null
  requestActionName: string
  startedSubmission: boolean
}

type STATE = {
  data: any[]
  filter: string
  pageDataPopulated: number[]
  pageNumber: number
  requestInProgress: boolean
  skip: number
  total: number
  value: any | undefined
}

type PA_CLIENT_RESPONSE = {
  gridContentInfo: GRID_CONTENT_INFO
  projectAClients: PA_CLIENT[]
}

const initialPaginationData = {
  data: [],
  pageDataPopulated: [],
  pageNumber: 0,
  skip: 0,
  total: 0
};

export class PaClient extends Component<PROPS, STATE> {

  static defaultProps: PROPS = {
    pageSize: 50,
    projectId: null,
    requestActionName: 'getPaClients',
    startedSubmission: false
  };

  state: STATE = {
    ...initialPaginationData,
    filter: '',
    requestInProgress: false,
    value: undefined
  };

  /**
   * Filter Change handler
   *
   * @param event
   */
  filterChange = (event: ComboBoxFilterChangeEvent): void => {
    const isInput = event.nativeEvent.type === 'input';
    this.setState({
      ...initialPaginationData,
      filter: event.filter.value
    }, () => {
      const delayFiltering = {
        buffer: isInput ? 300 : 1,
        pos: Position.end
      };
      this.dispatch(this.props.requestActionName, delayFiltering, this.prepareRequestParams(0));
    });
  };

  /**
   * Returns page data
   */
  getPaClientPageInfo = () => {
    const { pageSize } = this.props;
    const { pageNumber, filter: name = '' } = this.state;
    return {
      pageSize,
      pageNumber,
      name
    }
  };

  /**
   * Prepare params for combo action request
   *
   * @param pageNumber
   */
  prepareRequestParams = (pageNumber: number) => {
    const { pageSize, projectId } = this.props;
    const { filter: name } = this.state;
    return {
      name,
      pageSize,
      pageNumber,
      projectId
    }
  };

  /**
   * Sets PA client data - init load
   *
   * @param data
   */
  setPaClientData = (data: PA_CLIENT_RESPONSE) => {
    let { projectAClients = [], gridContentInfo } = data;
    const repackedData = {
      additionalInitData: {
        paClientName: ''
      },
      gridContentInfo,
      items: projectAClients
    };

    this.props.virtualScroll.setGridData(repackedData);
  };

  renderBody() {
    const { data, skip, total } = this.state;
    const {
      pageSize,
      startedSubmission,
      onChange,
      virtualScroll,
      value,
    } = this.props;
    const props = omit(this.props, ['startedSubmission', 'projectId', 'onChange']);
    let displayData: any[] = data ? data.slice(skip, skip + pageSize) : [];
    return (
      <FilterCombo
        {...props}
        aria-label={this.translate('paClient')}
        data={displayData}
        disabled={startedSubmission}
        filterable={true}
        filterChange={this.filterChange}
        id={'paClient'}
        label={this.translate('paClient')}
        listNoDataRender={() => noDataDropDownRender(this.translate('emptyPaClient'))}
        name='paClient'
        onChange={onChange}
        onPageChange={virtualScroll.pageChange}
        popupSettings={{ className: 'tp-select-organization-user-dropdown' }}
        textField={'paClientName'}
        translateMethod={this.translate.bind(this)}
        value={value}
        valueAsSimpleType={true}
        valueField={'paClientId'}
        virtual={{
          pageSize: pageSize,
          skip: skip,
          total: total
        }}
      />
    );
  }
}

export default virtualScroll(PaClient);